'use client'
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__base_ui_components_react_field_82c13e19__ from "@base-ui-components/react/field";
import * as __WEBPACK_EXTERNAL_MODULE__utils_cn_js_c08b6ef2__ from "../../utils/cn.js";
import * as __WEBPACK_EXTERNAL_MODULE__InputTextWrapper_js_cee711cd__ from "./InputTextWrapper.js";
import * as __WEBPACK_EXTERNAL_MODULE__Tooltip_utils_js_977daa12__ from "../Tooltip/utils.js";
import * as __WEBPACK_EXTERNAL_MODULE__InputText_variants_js_7e897728__ from "./InputText.variants.js";
const InputText_InputText = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ label, isLabelHidden, helperText, errorText, maxLength, iconLeft, iconRight, emphasis, isInset, size, className, isDisabled, errorMessage, validate, 'aria-invalid': ariaInvalid, validationMode = 'onBlur', onChange, ...props }, ref) {
    const { name, ...rest } = props;
    const [error, setError] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const [success, setSuccess] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const tooltipSideOffset = (0, __WEBPACK_EXTERNAL_MODULE__Tooltip_utils_js_977daa12__.getTooltipSideOffset)(size);
    const hasPlaceholder = Boolean(props.placeholder);
    const styles = (0, __WEBPACK_EXTERNAL_MODULE__InputText_variants_js_7e897728__.inputTextVariants)({
        emphasis,
        isDisabled,
        hasIconLeft: !!iconLeft,
        hasIconRight: !!iconRight,
        isInset,
        hasPlaceholder,
        size,
        error,
        success
    });
    function handleChange(event) {
        onChange?.(event);
    }
    const handleValidation = (value)=>{
        if (validate && 'string' == typeof value) {
            const isValid = validate(value);
            setError(!isValid);
            setSuccess(isValid);
        }
        return null;
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_field_82c13e19__.Field.Root, {
        name: name,
        className: (0, __WEBPACK_EXTERNAL_MODULE__utils_cn_js_c08b6ef2__.cn)(styles.root(), className),
        validate: handleValidation,
        disabled: isDisabled,
        validationMode: validationMode,
        children: [
            label ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_field_82c13e19__.Field.Label, {
                className: (0, __WEBPACK_EXTERNAL_MODULE__utils_cn_js_c08b6ef2__.cn)(styles.labelSlot(), isLabelHidden ? 'hidden' : ''),
                children: label
            }) : null,
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_field_82c13e19__.Field.Control, {
                render: (inputProps)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__InputTextWrapper_js_cee711cd__.InputTextWrapper, {
                        ...inputProps,
                        ...rest,
                        ref: ref,
                        styles: styles,
                        iconLeft: iconLeft,
                        ariaInvalid: Boolean(ariaInvalid),
                        errorText: errorText,
                        maxLength: maxLength,
                        onChange: handleChange,
                        error: error,
                        tooltipSideOffset: tooltipSideOffset,
                        errorMessage: errorMessage,
                        success: success,
                        iconRight: iconRight
                    })
            }),
            helperText || errorText || maxLength ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: styles.textSlot(),
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_field_82c13e19__.Field.Error, {
                        forceShow: Boolean(errorText),
                        className: styles.errorTextSlot(),
                        "aria-live": "assertive",
                        children: errorText
                    }),
                    !errorText && helperText ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_field_82c13e19__.Field.Description, {
                        className: styles.helperTextSlot(),
                        "aria-live": "polite",
                        children: helperText
                    }) : null,
                    maxLength && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: styles.characterCount(),
                        children: [
                            "0/",
                            maxLength
                        ]
                    })
                ]
            }) : null
        ]
    });
});
export { InputText_InputText as InputText };
